import SodMessage from './SodMessage';

export default SodMessage;
